var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChooseCode = function SvgChooseCode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00A0CB",
    fillRule: "evenodd",
    d: "M9.8.75a1.6 1.6 0 0 1 .25 2.248l-5.601 7 5.6 7.001a1.6 1.6 0 0 1-2.499 2l-6.4-8a1.6 1.6 0 0 1 0-2l6.4-8A1.6 1.6 0 0 1 9.8.75M22.2.75a1.6 1.6 0 0 0-.25 2.248l5.6 7L21.95 17a1.6 1.6 0 0 0 2.5 2l6.4-8a1.6 1.6 0 0 0 0-2l-6.4-8A1.6 1.6 0 0 0 22.2.75M18.394.456A1.644 1.644 0 0 1 19.55 2.43l-4.01 15.984a1.56 1.56 0 0 1-1.935 1.126 1.644 1.644 0 0 1-1.158-1.975l4.01-15.984A1.56 1.56 0 0 1 18.394.456",
    clipRule: "evenodd"
  })));
};
export default SvgChooseCode;